import { connect } from "react-redux";
import CreateHsn from "./CreateHsn";
import { bindActionCreators } from "redux";
import { getGstList, createDeleteHsn } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  gstList: state.businessItemReducer.gstList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getGstList,
      createDeleteHsn,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateHsn);
